import { Box, Button, Typography } from "@mui/material";
import { NoGroupsFigures } from "../../../../assets/icons/MUI/GroupsIcons";
import { useTranslation } from "react-i18next";
import { colors } from "../../../../theme/palette";
import { useNavigate } from "react-router-dom";
import APP_ROUTES from "../../../../routers/routeConstants";

const NoGroupsCreatedFigure = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        rowGap: "28px",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
      }}
    >
      <NoGroupsFigures />
      <Typography variant="body14Regular" sx={{ color: colors.Dark600 }}>
        {t("pages.entity.groups.noGroupsYet")} <br />
        {t("pages.entity.groups.startExploring")}
      </Typography>
      <Button variant="primary-sm" sx={{ width: "fit-content" }} onClick={() => navigate(APP_ROUTES.CREATE_GROUP)}>
        {t("pages.entity.groups.createFirstGroup")}
      </Button>
    </Box>
  );
};

export default NoGroupsCreatedFigure;
